import { useMutation } from 'hooks/useMutation'
import { useQuery } from 'hooks/useQuery'
import { useQueryClient } from 'hooks/useQueryClient'

import { fetchActivityTypes, postActivityTypes } from 'utils/queries/activityTypes'

import { ActivityGroup } from 'types/activityType'

export const useActivityTypes = () => {
  const queryClient = useQueryClient()

  const typesQuery = useQuery(['activityTypes'], () => fetchActivityTypes())

  const postData = useMutation<unknown>(() => postActivityTypes(), {
    onSuccess: () => queryClient.invalidateQueries('activityTypes', { refetchInactive: true }),
  })

  return {
    postData,
    types: {
      workout: typesQuery.data?.activityGroups[0] as ActivityGroup,
      sport: typesQuery.data?.activityGroups[1] as ActivityGroup,
      recovery: typesQuery.data?.activityGroups[2] as ActivityGroup,
      mindfulness: typesQuery.data?.activityGroups[3] as ActivityGroup,
    },
  }
}
